<template>
  <div>
    <i
      class="bx bx-plus-medical"
      style="color:green;cursor:pointer;"
      @click="$bvModal.show(personFullname + personUserID + index)"
      >Προσθήκη
    </i>
    <b-modal
      :id="personFullname + personUserID + index"
      title="Προσθήκη Χτυπήματος"
      centered
      hide-footer
    >
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">
              Προσθήκη Χτυπήματος - {{ personFullName }}
            </h4>
            <b-spinner
              v-show="spinner"
              class="m-2"
              variant="primary"
              role="status"
            ></b-spinner>

            <form
              class="needs-validation"
              @submit.prevent="confirmAddAttendances"
            >
              <div class="row">
                <div class="col-md-12">
                  <div class="mb-3">
                    <label for="validationCustom01"
                      >Ημερομηνία και Ωρα Χτυπήματος Κάρτας</label
                    >
                    <div class="col-md-12">
                      <div class="mb-3">
                        <label class="mt-3">Ημερομηνία</label>
                        <b-form-datepicker
                          :value="date"
                          calendarWidth="300"
                          :start-weekday="1"
                          confirm
                          locale="el"
                          disabled
                        ></b-form-datepicker>
                      </div>
                      <div class="mb-3">
                        <label class="mt-3">Ώρα Έναρξης</label>
                        <date-picker
                          v-model="startTime"
                          format="HH:mm"
                          value-type="format"
                          type="time"
                          placeholder="hh:mm"
                        ></date-picker>
                      </div>
                      <div class="mb-3">
                        <label class="mt-3">Ώρα Λήξης</label>
                        <date-picker
                          v-model="endTime"
                          format="HH:mm"
                          value-type="format"
                          type="time"
                          placeholder="hh:mm"
                        ></date-picker>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <button class="btn btn-primary" type="submit">
                Ολοκλήρωση
              </button>
            </form>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
// import session from "../../../../api/session";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import { eventCreate } from "../../../../eventspy.js";
import Swal from "sweetalert2";
import session from "../../../../api/session.js";
export default {
  components: {
    DatePicker,
  },
  props: [
    "date",
    "personUserId",
    "personFullname",
    "personID",
    "index",
    "workingSchedule",
  ],
  data() {
    return {
      startTime: "",
      endTime: "",
      attendanceDate: this.date,
      personUserID: this.personUserId,
      personFullName: this.personFullname,
      personId: this.personID,
      spinner: false,
    };
  },
  methods: {
    workingScheduleNightShift() {
      const firstAttendance = {
        timestamp: moment(this.date + " " + this.startTime).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        punch: 0,
        status: 2,
        user_id: this.personUserID,
        device: "ΚΑΤ' ΕΝΤΟΛΗ",
      };
      const nextDate = moment(this.date).add(1, "day");
      const secondAttendance = {
        timestamp: moment(
          nextDate.format("YYYY-MM-DD") + " " + this.endTime
        ).format("YYYY-MM-DD HH:mm:ss"),
        punch: 0,
        status: 2,
        user_id: this.personUserID,
        device: "ΚΑΤ' ΕΝΤΟΛΗ",
      };

      console.log(this.personID);
      const requestData = {
        first_attendance: firstAttendance,
        second_attendance: secondAttendance,
        person: this.personID,
      };

      session
        .post("api/reschedule-nigth-shift/absence/", requestData)
        .then((resp) => {
          console.log(resp.data);
          this.$toastr.Add({
            name: "UniqueToastName",
            title: `Ενημέρωση ${this.personFullName}`,
            msg: "Έγινε υπολογισμός!",
            style: { backgroundColor: "#4fd69c", width: "550px" },
            progressbar: false,
            timeout: 2000,
          });
          eventCreate(
            `Δημιουργία Reschedule Απουσιες ${JSON.stringify(this.personId)}`,
            1
          );
          this.spinner = false;
          this.$bvModal.hide(
            this.personFullname + this.personUserID + this.index
          );

          this.$emit("Created");
        })
        .catch((e) => {
          console.log(e);
          Swal.fire(
            "Κάτι πήγε στραβά",
            "Ο χρήστης δεν έχει ζυγά χτυπήματα, παρακαλώ Επικοινωνήστε με τους διαχειριστές",
            "error"
          );
          return;
        });
      return;
    },
    confirmAddAttendances() {
      if (!this.startTime || !this.endTime) {
        Swal.fire(
          "Προσοχή",
          "Παρακαλώ εισάγεται Ώρα Έναρξης και Ώρα Λήξης",
          "error"
        );
        return;
      }
      if (
        this.workingSchedule.length > 0 &&
        this.workingSchedule[0].is_night_shift
      ) {
        this.workingScheduleNightShift();
        return;
      }

      const attendances = [];
      const startAttendance = {
        timestamp: moment(this.date + " " + this.startTime).format(),
        punch: 0,
        status: 2,
        user_id: this.personUserID,
        device: "ΚΑΤ' ΕΝΤΟΛΗ",
      };
      attendances.push(startAttendance);
      const endAttendance = {
        timestamp: moment(this.date + " " + this.endTime).format(),
        punch: 0,
        status: 2,
        user_id: this.personUserID,
        device: "ΚΑΤ' ΕΝΤΟΛΗ",
      };
      attendances.push(endAttendance);
      this.spinner = true;

      attendances.forEach((data) => {
        session
          .post("api/attendance/create/", data)
          .then(() => {
            eventCreate(
              `Δημιουργία Attendance Απουσιες Person_device:${this.personUserId} ${data}`,
              1
            );
          })
          .catch((e) => {
            console.log(e.response.data);
          });
      });

      setTimeout(() => {
        session
          .get(`api/reschedule/?person=${this.personId}&date=${this.date}`)
          .then((resp) => {
            console.log(resp.data);
            if (resp.data.detail == "error hits") {
              Swal.fire(
                "Κάτι πήγε στραβά",
                "Ο χρήστης δεν έχει ζυγά χτυπήματα, παρακαλώ Επικοινωνήστε με τους διαχειριστές",
                "error"
              );
              return;
            } else {
              this.$toastr.Add({
                name: "UniqueToastName",
                title: `Ενημέρωση ${this.personFullName}`,
                msg: "Έγινε υπολογισμός!",
                style: { backgroundColor: "#4fd69c", width: "550px" },
                progressbar: false,
                timeout: 2000,
              });
              eventCreate(
                `Δημιουργία Reschedule Απουσιες ${JSON.stringify(
                  this.personId
                )}`,
                1
              );
              this.spinner = false;
              this.$bvModal.hide(
                this.personFullname + this.personUserID + this.index
              );

              this.$emit("Created");
            }
          });
      }, 1500);

      //   }
    },
  },
};
</script>
